import angular from 'angular'
import comp from './modal.component'

export default angular
  .module('ellipsis.modal', [])
  .component('ellipsisModal', comp)
